module.exports = __webpack_public_path__ + "img/nature-53.1c66b79c.jpg";